import { FlightType } from "./features/aircraft/types";

export const localIp = "nano.m4mga3.com";
export const localIps = ["localhost", "127.0.0.1"];

export const isLocalIp = (ip: string): boolean => {
  return localIps.some((localIp) => ip.includes(localIp));
};

export const flightTypeEnum: { [key in FlightType]: number } = {
  DEV_INDOOR: 1001,
  DEV_FLIGHT: 1002,
  TRAINING: 1004,
  PRODUCTION: 1005,
  SITL: 1006,
  VOLUME_TESTING: 1007,
  STAGING: 1008,
  MANUAL: 1009,
  LFRT: 1010,
  SFRT: 1011,
  PRE_PROD: 1012,
  NOT_SET: 0,
};
